import React, { Component } from "react";
import { PureComponent } from "react";
import PrintStats from "./printStats";

class PlayerStatsSeason extends PureComponent {
  constructor(props) {
    super(props);
    // this.autoComplete.bind(this)
  }

  render() {
    let { trans, config, player, currMatchDay, playerDetailsObj, getTrans } =
      this.props;

    let statsObj = playerDetailsObj.overallStats;
    let pointsObj = playerDetailsObj.overallPoints;
    let matchStatus = currMatchDay.matchStatus;

    const pData = playerDetailsObj;

    const isTourActive = pData.isTourActive === 1 || pData.isTourActive === "1";
    const isFixtureUpdated =
      pData.isFixtureUpdated === 1 || pData.isFixtureUpdated === "1";

    let seasonStatsBlock = "";

    if (statsObj["oF"] > 0) {
      seasonStatsBlock = (
        <>
          <div className="si-pts__heading">
            {isTourActive && isFixtureUpdated
              ? getTrans(trans, "thisSeason", "This Season")
              : getTrans(trans, "lastSeason", "Last Season")}
          </div>
          <div className="si-pts__details si-curved-sm si-bg--plyr-card">
            <div className="si-pts__graph-details">
              {statsObj && Object.keys(statsObj).length > 0 ? (
                <PrintStats
                  statsObj={statsObj}
                  pointsObj={pointsObj}
                  getTrans={getTrans}
                  trans={trans}
                  playerDetailsObj={playerDetailsObj}
                  pointsByMD={false}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      );
    } else {
      if (isTourActive == 0) {
        seasonStatsBlock = <div style={{ height: "40px" }}></div>;
      } else {
        seasonStatsBlock = !(isTourActive && isFixtureUpdated) ? (
          <>
            <div className="si-pts__heading">
              {isTourActive && isFixtureUpdated
                ? getTrans(trans, "lastSeasonYear", "Season 19/20")
                : getTrans(trans, "lastSeason", "Last Season")}
            </div>
            <div className="si-pts__details si-curved-sm si-bg--plyr-card">
              <div className="si-pts__graph-details">
                <div className="si-training-details">
                  <div className="si-training-type">
                    <span>
                      {getTrans(
                        trans,
                        "notInlastSeason",
                        "Did not play last season"
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div style={{ height: "40px" }}></div>
        );
      }
    }

    return seasonStatsBlock;
  }
}

export default PlayerStatsSeason;
